import {useInteractions} from '../hooks'
import {FloatingNode} from '@floating-ui/react'
import {FloatingContext} from './floating_context'

const {Provider} = FloatingContext

export const FloatingProvider = ({floating, config = {}, interactions = [], children, ...rest}) => {
	const {nodeId, context, isNested} = floating
	const _interactions = useInteractions({context, config, interactions, isNested})

	const value = {
		...floating,
		..._interactions,
		isNested,
		...rest,
	}

	return (
		<Provider value={value}>
			<FloatingNode id={nodeId}>{children}</FloatingNode>
		</Provider>
	)
}
